import React, { useState } from "react";
import { useNavigate, Link, useLocation } from "react-router-dom";
import { Truck, Loader2 } from "lucide-react";
import { useAuth } from "../context/AuthContext";

const AuthPage = ({ mode }) => {
  const isLogin = mode === "login";
  const { login, register } = useAuth();
  const navigate = useNavigate();
  const location = useLocation();
  const [form, setForm] = useState({ name: "", email: "", password: "" });
  const [error, setError] = useState("");
  const [busy, setBusy] = useState(false);

  const redirectFor = (user) => {
    const dest = location.state?.from || (user.role === "admin" ? "/admin" : "/portal");
    navigate(dest, { replace: true });
  };

  const handleChange = (e) => setForm({ ...form, [e.target.name]: e.target.value });

  const handleSubmit = async (e) => {
    e.preventDefault();
    setError("");
    setBusy(true);
    try {
      const user = isLogin
        ? await login(form.email, form.password)
        : await register({ name: form.name, email: form.email, password: form.password });
      redirectFor(user);
    } catch (err) {
      setError(err?.response?.data?.detail || "Something went wrong. Please try again.");
    } finally {
      setBusy(false);
    }
  };

  return (
    <div className="auth-wrap">
      <div className="auth-card">
        <Link to="/" className="auth-brand">
          <span className="auth-logo"><Truck size={22} /></span>
          <span>
            <span className="auth-brand-top">FLYING FLEET</span>
            <span className="auth-brand-bottom">DISPATCH LLC</span>
          </span>
        </Link>
        <h1>{isLogin ? "Welcome back" : "Create your account"}</h1>
        <p className="auth-sub">
          {isLogin ? "Log in to your dispatch portal." : "Sign up to upload documents and get dispatched."}
        </p>

        {error && <div className="auth-error">{error}</div>}

        <form onSubmit={handleSubmit} className="auth-form">
          {!isLogin && (
            <div className="field">
              <label htmlFor="name">Full Name</label>
              <input id="name" name="name" required value={form.name} onChange={handleChange} placeholder="Jane Trucker" />
            </div>
          )}
          <div className="field">
            <label htmlFor="email">Email</label>
            <input id="email" name="email" type="email" required value={form.email} onChange={handleChange} placeholder="you@email.com" />
          </div>
          <div className="field">
            <label htmlFor="password">Password</label>
            <input id="password" name="password" type="password" required minLength={6} value={form.password} onChange={handleChange} placeholder="••••••" />
          </div>
          <button type="submit" className="btn btn-primary btn-block" disabled={busy}>
            {busy ? <Loader2 size={16} className="spin" /> : null}
            {isLogin ? "Log In" : "Sign Up"}
          </button>
        </form>

        <p className="auth-switch">
          {isLogin ? (
            <>New here? <Link to="/signup">Create an account</Link></>
          ) : (
            <>Already have an account? <Link to="/login">Log in</Link></>
          )}
        </p>
      </div>
    </div>
  );
};

export default AuthPage;
